import { IntlShape } from "react-intl";

import { capitalizeNow } from "components/presenters/AirTimeV2/utils";
import { AiringDateProps } from "components/widgets/CardView/types";


function isEmptyString(str: string): boolean {
  if (!str) {
    return true;
  }

  const cleaned = str.replace(/[\s\u200B-\u200F\uFEFF]/g, '');

  return cleaned.length === 0;
}
interface Props {
  title: string;
  shouldPronouncedAiringTime?: boolean;
  channelName?: string;
  placeDescription?: string;
  description?: string;
  airingObject?: AiringDateProps | undefined;
  intl: IntlShape;
  isRestricted?: boolean;
  isPurchaseContent?: boolean;
  isRecord?: boolean;
  isSeriesRecord?: boolean;
}
// TODO Need to be covered by units
export function getAriaLabelForAsset( {
  intl,
  title,
  channelName,
  airingObject,
  description,
  isRestricted,
  isPurchaseContent,
  shouldPronouncedAiringTime,
  isRecord,
  isSeriesRecord
}: Props): string{
  if (isRestricted) {
    return intl.formatMessage({ defaultMessage: 'restricted content', id: 'General.RestrictedContent' })
  }

  if (isEmptyString(title) && !description && !channelName) {
    return intl.formatMessage({ defaultMessage: 'Untitled content', id: 'General.NoContentLabel' });
  }

  const result = [];

  if (shouldPronouncedAiringTime && airingObject?.airingTime) {
    let resolveAiringLabel;

    if(!airingObject.airingLabel  && airingObject.isFutureDate){
      resolveAiringLabel = airingObject.withLongWeekdayFormattedDate;
    } else {
      resolveAiringLabel = airingObject.airingLabel && capitalizeNow(airingObject.airingLabel);
    }

    const label = resolveAiringLabel ? intl.formatMessage({ defaultMessage: resolveAiringLabel, id:`Rail.RailCard.AirTime.${resolveAiringLabel}` }) : intl.formatMessage({ defaultMessage:'Now', id:'Rail.RailCard.AirTime.Now' });

    result.push(`${airingObject.airingTime} ${label}`);
  }

  if (isPurchaseContent) {
    result.push(intl.formatMessage({ defaultMessage: 'content to purchase', id: 'General.PurchaseContent' }));
  }

  if (channelName) {
    result.push(channelName);
  }

  if (title) {
    result.push(title);
  }

  if (description) {
    result.push(description);
  }

  if (isRecord && !isSeriesRecord) {
    result.push(intl.formatMessage({ defaultMessage: 'recorded', id: 'General.RecordedSingleContent' }))
  } else if (isSeriesRecord) {
    result.push(intl.formatMessage({ defaultMessage: 'series', id: 'General.RecordedSeriesContent' }))
  }

  return result.join(' ');
}
